/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var XSquareIcon16Solid = forwardRef('XSquareIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 1A3.5 3.5 0 0 0 1 4.5v7A3.5 3.5 0 0 0 4.5 15h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 11.5 1h-7Zm1.325 3.41a1 1 0 0 0-1.414 1.415L6.586 8 4.41 10.175a1 1 0 1 0 1.414 1.414L8 9.414l2.175 2.175a1 1 0 0 0 1.414-1.414L9.414 8l2.175-2.175a1 1 0 0 0-1.414-1.414L8 6.586 5.825 4.41Z" })));
});
